import Card from './Card';
import CardBody from './CardBody';
import CardHeader from './CardHeader';
import CardFooter from './CardFooter';

// export types
export type { CardProps } from './Card';
export type { CardBodyProps } from './CardBody';
export type { CardHeaderProps } from './CardHeader';
export type { CardFooterProps } from './CardFooter';

// export components
export { Card, CardBody, CardHeader, CardFooter };
export default Card;
